import React from "react";
import NextScript from "next/script";

const MicrosoftUET = ({ uetTagId: uetTagIdProp }: { uetTagId?: string | null } = {}) => {
  // DB-backed prop wins, else NEXT_PUBLIC_MICROSOFT_UET_TAG_ID.
  const uetTagId =
    (uetTagIdProp && uetTagIdProp.trim()) ||
    process.env["NEXT_PUBLIC_MICROSOFT_UET_TAG_ID"];

  // Return null silently if ID is not configured (no errors/warnings)
  if (!uetTagId) {
    return null;
  }

  return (
    <>
      <link rel="preconnect" href="https://bat.bing.com" />
      {/* Microsoft UET (Bing Ads) Tracking Script */}
      <NextScript
        id="microsoft-uet-script"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,t,r,u){
              var f,n,i;
              w[u]=w[u]||[];
              f=function(){
                var o={ti:"${uetTagId}", enableAutoSpaTracking: true};
                o.q=w[u];
                w[u]=new UET(o);
                w[u].push("pageLoad");
              };
              n=d.createElement(t);
              n.src=r;
              n.async=1;
              n.onload=n.onreadystatechange=function(){
                var s=this.readyState;
                s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null);
              };
              i=d.getElementsByTagName(t)[0];
              i.parentNode.insertBefore(n,i);
            })(window,document,"script","//bat.bing.com/bat.js","uetq");
          `,
        }}
      />
    </>
  );
};

export default MicrosoftUET;
